import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  deleteMerchantFacadePictures,
  getMerchantFacadePictures,
  resetState,
} from "../../store/actions/MerchantFacade";
import ListPagination from "../../components/Common/ListPagination";
import MerchantFacadeList from "../../components/MerchantFacade/MerchantFacadeList";
import MerchantFacadeFilterModal from "../../components/MerchantFacade/MerchantFacadeFilterModal";
import FilterButton from "../../components/Common/FilterButton";
import Button from "sushiweb/Button";
import MerchantFacadeAddModal from "../../components/MerchantFacade/MerchantFacadeAddModal";

const MerchantFacade = ({
  getMerchantFacadePictures,
  activeFilters,
  merchantFacadePicturesList,
  prevPage,
  nextPage,
  deleteMerchantFacadePictures,
  resetState,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
      getMerchantFacadePictures(activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
      getMerchantFacadePictures(activeFilters, pageRequest);
    }
  };

  const handleFilterClick = () => {
    setShowFilterModal(true);
  };

  const handleAddClick = () => {
    setShowFormModal(true);
  };

  const handleFormClose = () => {
    setShowFormModal(false);
  };

  const handleClose = () => {
    setShowFilterModal(false);
  };

  useEffect(() => {
    const pageRequest = {
      page: currentPage,
      page_size: 10,
    };
    getMerchantFacadePictures(activeFilters, pageRequest);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFilters)]);

  return (
    <MerchantFacadeDashboardContainer>
      <FlexContainer className="mb-20" align="flex-start">
        <Heading>Merchant Facade Pictures</Heading>
        <FlexContainer className="mb-20" align="flex-start">
          <FilterButton
            activeFilters={activeFilters}
            handleClick={handleFilterClick}
          />
          <Button
            onClick={() => handleAddClick("Add", null)}
            className="sushi-btn ml-12"
            data-testid="MerchantFacadeAddBtn"
          >
            Add New
          </Button>
        </FlexContainer>
      </FlexContainer>
      <MerchantFacadeList
        deleteMerchantFacadePictures={deleteMerchantFacadePictures}
        list={merchantFacadePicturesList}
        getMerchantFacadePictures={getMerchantFacadePictures}
        activeFilters={activeFilters}
        currentPage={currentPage}
      />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {showFilterModal && (
        <MerchantFacadeFilterModal
          handleClose={handleClose}
          getMerchantFacadePictures={getMerchantFacadePictures}
          activeFilters={activeFilters}
          resetState={resetState}
        />
      )}
      {showFormModal && (
        <MerchantFacadeAddModal handleClose={handleFormClose} />
      )}
    </MerchantFacadeDashboardContainer>
  );
};

const MerchantFacadeDashboardContainer = styled.section``;

function mapStateToProps(state) {
  const { MerchantFacade } = state;
  return {
    activeFilters: MerchantFacade.activeFilters,
    merchantFacadePicturesList: MerchantFacade.merchantFacadePicturesList,
    prevPage: MerchantFacade.prevPage,
    nextPage: MerchantFacade.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getMerchantFacadePictures: bindActionCreators(
      getMerchantFacadePictures,
      dispatch
    ),
    deleteMerchantFacadePictures: bindActionCreators(
      deleteMerchantFacadePictures,
      dispatch
    ),
    resetState: bindActionCreators(resetState, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MerchantFacade);
